
import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import { formatNumber, formatMoney } from 'utils/currencyFormat';
import  danhSachThongTinVayApi  from "../../../service/ChoThongTin/danhSachThongTinVayApi";
import { pushNotification } from "utils/notifications";
import userApi from "../../../service/userApi";

export const PopupChiTiet = (props) => {
  const [objData, setData] = useState({});
  useEffect(() => {
    userApi.getCurrentUser().then((dataUser) => {
      var obj = {
        IdThongTin: props.data.Id, 
        IdCuaHang: dataUser.data.CompanyID,  
        TenCuaHang: dataUser.data.CompanyName,
        TenKhachHang: dataUser.data.NameDaiDien,
        TaiKhoanChu: dataUser.data.Administrator,
      };
      setData(obj);
    });
  }, []);
  const muaThongTin = ()=>{
      danhSachThongTinVayApi.muaThongTin(objData).then((response) => {
        if(response.status == 500){
          pushNotification(
            response.data,
            "error",
            "TOP_RIGHT",
            2000
          );
        }else{
          pushNotification(
            "Thao tác thành công",
            "success",
            "TOP_RIGHT",
            2000
          );
          setTimeout(function () {
            window.location.href = "/trang-chu/Thank-You.aspx";
          }, 2000);
        }        
        
      });
 

   
  }
  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-clipboard-text-outline"></i>
          </span>{" "}
          Chi tiết thông tin vay
        </h4>
        <button
          type="button"
          className="close-popup-new"
          data-dismiss="modal"
          aria-label="Close"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form tat-toan">
          <div className="form-body">
            <div className="card collapse-icon accordion-icon-rotate">
              <div
                id="headingCollapse53"
                className="card-header border-info"
                href="#collapse53"
                aria-expanded="true"
                aria-controls="collapse53"
              >
                <a
                  className="card-title lead info collapsed"
                  href={() => false}>
                  <h3>Thông tin vay</h3>
                </a>
              </div>
              <div
                id="c e53"
                aria-labelledby="headingCollapse53"
                className="card-collapse collapse show"
                aria-expanded="true"
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="form-group row">
                      <label className="col-md-2 label-control">
                         Ngày đăng ký
                      </label>
                      <div className="col-md-4">
                      {moment(props.data.NgayTao).format("HH:mm DD/MM/YYYY")}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-2 label-control">
                          Họ Tên
                      </label>
                      <div className="col-md-4">
                            {props.data.HoVaTen}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-2 label-control">
                          Địa chỉ
                      </label>
                      <div className="col-md-10">
                        {props.data.DiaChi}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-2 label-control">
                         Số tiền vay
                      </label>
                      <div className="col-md-4">
                      {formatMoney(props.data.SoTienVay)}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-2 label-control">
                         Số điện thoại
                      </label>
                      <div className="col-md-4">
                        {props.data.DienThoaiChe}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-2 label-control">
                         Nội dung
                      </label>
                      <div className="col-md-4">
                        {props.data.GhiChu}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-2 label-control">
                         Giá thông tin
                      </label>
                      <div className="col-md-4">
                        0
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
      <a
          className="btn btn-new-main btn-checknew"
          data-dismiss="modal"
          href={() => false}
          onClick={muaThongTin}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-check"></i>
          </span>{" "}
          Mua thông tin
        </a>

        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>{" "}
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
